import type { z } from "zod";

import { collectionSchema } from "./collectionSchema";

export const sectionItemCollectionSchema = collectionSchema.omit({
  prayers: true,
});

export type SectionItemCollection = z.infer<typeof sectionItemCollectionSchema>;
